import CountryPageRenderer from '../components/CountryPageRenderer';
import germanyData from '../data/country-pages/germany';

export default function GermanyCountryPage() {
  return <CountryPageRenderer data={germanyData} />;
}
